import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import SignupForm from "./components/signup";
import Login from "./components/login";
import ForgotPassword from "./components/forgotpassword";
import VerifyCode from "./components/verifycode";
import LoginForgotPassword from "./components/login";
import HomePage from "./components/homepage";
import ResetPassword from "./components/resetpassword";
import Auth from "./components/Auth";
import FriendsFollowers from "./components/friendsfollowers";
import VerifyCodeSignup from "./components/verifycodeforsignup";
import HomePageNew from "./components/homenew";
import Myprofile from"./components/profile";
import GoogleAuthCallback from "./components/googleAuth";
import Navbar from"./components/sidebar/leftsidebar";
import Groupsandfamily from "./components/groupsandfamily";
import './index.css';
import "flowbite";
import Profileedit from"./components/profileedit";
import VerifyCodeMobile from "./components/verifycodemobile";
import Signinwithmobile from "./components/signinwithmobile";
import Golive from "./components/golive";
import Account from "./components/Account";
import { SearchProvider } from './context/SearchContext';
import Viewpost from './components/feedpost/viewpost';
import TermsConditions from './components/TermsConditions';
import ProfileView from './components/profileview';
import Profilefollowers from './components/profilefollowers';

export default function App() {
  return (
    <SearchProvider>
      <Router>
        <div className="flex flex-col items-center justify-center min-h-screen ">
          {/* <h1 className="text-3xl font-bold text-gray-700 mb-6">Welcome</h1> */}
          <div className="flex space-x-4">
            {/* <Link to="/login" className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600">
              Login
            </Link>
            <Link to="/signup" className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600">
              Signup
            </Link> */}
          </div>
          <Routes>
            <Route path="/" element={<Login />} />

            <Route path="/signup" element={<SignupForm />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/verifycode" element={<VerifyCode />} />
            <Route path="/login" element={<LoginForgotPassword />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/friendsfollowers" element={<FriendsFollowers />} />
            <Route path="/verifycodeforsignup" element={<VerifyCodeSignup />} />
            <Route path="/homenew" element={<HomePageNew />} />
            <Route path="/myprofile" element={<Myprofile />} />
            <Route path="/navbar" element={<Navbar />} />
            <Route path="/auth/callback" element={<GoogleAuthCallback />} />
            <Route path="/signtest" element={<GoogleAuthCallback />} />
            <Route path="/verifycodemobile" element={<VerifyCodeMobile />} />
            <Route path="/myprofileedit" element={<Profileedit />} />
            <Route path="/groupsfamily" element={<Groupsandfamily />} />
            <Route path="/signinwithmobile" element={<Signinwithmobile />} />
            <Route path="/account" element={<Account />} />
            <Route path="/golive" element={<Golive />} />
            <Route path="/viewpost" element={<Viewpost />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/myprofile/:id" element={<ProfileView />} />
            <Route path="/profilefollowers" element={<Profilefollowers />} />

            {/* You can add a Login component here later */}
          </Routes>
        </div>
      </Router>
    </SearchProvider>
  )
}

